import React, { useState, useEffect } from "react";
import square from "../../../Assets/svg/add-square 1.svg";
import "./CardResponsive.scss";
import zarbdar from "../../../Assets/svg/add 3.svg";

const CardResponsive = ({ backendData, initialData, onTotalInvoiceChange }) => {
  const [selectedService, setSelectedService] = useState("");
  const [cards, setCards] = useState([]);
  const [invoiceTotal, setInvoiceTotal] = useState(() => {
    const initialTotal = (initialData.typeOfServices ?? []).reduce(
      (total, service) => {
        return total + Number(service.price);
      },
      0
    );
    return initialTotal;
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedService) {
      alert("Please select a service type.");
      return;
    }

    const selectedOption = initialData.typeOfServices.find(
      (option) => option.value === selectedService
    );

    if (!selectedOption) {
      alert("Invalid selected service.");
      return;
    }

    const existingCard = cards.find(
      (card) => card.serviceType === selectedOption.label
    );

    if (existingCard) {
      // If a card with the same serviceType already exists, update it.
      const updatedCard = {
        ...existingCard,
        quantity: existingCard.quantity + 1,
        total: (existingCard.quantity + 1) * Number(existingCard.serviceAmount),
      };

      setCards((prevCards) => {
        // Replace the existing card with the updated one.
        return prevCards.map((card) =>
          card.serviceType === selectedOption.label ? updatedCard : card
        );
      });
    } else {
      // If it doesn't exist, create a new card.
      const newCard = {
        invoiceNumber: selectedOption.InvoiceNumber,
        serviceType: selectedOption.label,
        serviceAmount: selectedOption.price,
        quantity: 1,
        total: Number(selectedOption.price),
      };

      setCards([...cards, newCard]);
    }

    setInvoiceTotal((prevTotal) => prevTotal + Number(selectedOption.price));

    setSelectedService("");
  };

  const handleDeleteCard = (index) => {
    const cardToDelete = cards[index];
    setInvoiceTotal((prevTotal) => prevTotal - cardToDelete.total);
    const updatedCards = cards.filter((card, i) => i !== index);
    setCards(updatedCards);
  };

  const handleQuantityChange = (index, newQuantity) => {
    setCards((prevCards) =>
      prevCards.map((card, idx) =>
        idx === index
          ? {
              ...card,
              quantity: newQuantity,
              total: Number(card.serviceAmount) * newQuantity,
            }
          : card
      )
    );

    calculateInvoiceTotal();
  };

  const handlePriceChange = (index, newPrice) => {
    setCards((prevCards) =>
      prevCards.map((card, idx) =>
        idx === index
          ? {
              ...card,
              serviceAmount: newPrice,
              total: Number(newPrice) * card.quantity,
            }
          : card
      )
    );

    calculateInvoiceTotal();
  };

  const calculateInvoiceTotal = () => {
    let total = 0;
    cards.forEach((card) => {
      total += card.total;
    });
    setInvoiceTotal(total);

    onTotalInvoiceChange(total);
  };

  const formatNumberWithCommas = (number) => {
    return number.toLocaleString("en-US");
  };

  useEffect(() => {
    calculateInvoiceTotal();
  }, [cards]);

  useEffect(() => {
    debugger;
    if (
      backendData &&
      backendData.factorDetail &&
      backendData.factorDetail.length > 0
    ) {
      debugger;
      // Map the factorDetail data to create cards.
      const updatedCards = backendData.factorDetail.map((detail) => ({
        invoiceNumber: detail.InvoiceNumber,
        serviceType: detail.TypeOfService,
        serviceAmount: detail.AmountOfService,
        quantity: detail.number,
        total: Number(detail.AmountOfService) * Number(detail.number),
      }));

      setCards(updatedCards);
    }
  }, [backendData]);

  return (
    <div className="CardFactor">
      <div className="topOfTable">
        <form onSubmit={handleSubmit}>
          <div className="TypeOfService">
            <label>نوع خدمات</label>
            <select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
            >
              <option value="">نوع خدمات را انتخاب کنید</option>
              {Array.isArray(initialData.typeOfServices) &&
                initialData.typeOfServices.length > 0 &&
                initialData.typeOfServices.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
          <button className="btn btnCustom btnSubmit">
            <img src={square} alt="" />
          </button>
        </form>
      </div>
      <div className="cardList">
        {cards.map((card, index) => (
          <div className="card" key={index}>
            {card.invoiceNumber && (
              <div className="invoiceNumber">
                <span className="spanInvoiceNumber">شماره فاکتور :</span>
                <span className="spanInvoiceNum">{card.invoiceNumber}</span>
              </div>
            )}
            <div className="serviceType">
              <span className="spanserviceType">نوع خدمات :</span>
              <span className="spanType">{card.serviceType}</span>
            </div>
            <div className="serviceAmount">
              <span className="spanserviceAmount"> مبلغ خدمات:</span>
              <input
                type="number"
                value={card.serviceAmount}
                onChange={(e) => handlePriceChange(index, e.target.value)}
                min={0}
              />
            </div>
            <div className="quantity">
              <span className="spanquantity"> تعداد:</span>
              <input
                type="number"
                value={card.quantity}
                onChange={(e) => handleQuantityChange(index, e.target.value)}
                min={1}
              />
            </div>
            <div className="total">
              <span className="spantotal">جمع کل :</span>
              <span className="spantotalNum">
                {formatNumberWithCommas(card.total)} ریال
              </span>
            </div>
            <div className="delete">
              <span className="spandelete">عملیات</span>
              <div
                className="deleteIcon"
                onClick={() => handleDeleteCard(index)}
              >
                <img src={zarbdar} alt="Delete" />
              </div>
            </div>

            <div className="borderUnderTable">
              <div className="border"></div>
            </div>
          </div>
        ))}
      </div>
      <div className="btnSum">
        <span>جمع کل فاکتور:</span>
        <span className="sumNum">
          {formatNumberWithCommas(invoiceTotal)} ریال
        </span>
      </div>
    </div>
  );
};

export default CardResponsive;
